// Export the data array directly
export const imageData = [
    {
      id: 1,
      title: "Over Thinker",
      image: "/images/overThinker.webp",
      category: "drama"
    },
    {
      id: 2,
      title: "Movie Two",
      image: "/images/overThinker.webp",
      category: "action"
    },
    {
      id: 3,
      title: "Movie Three",
      image: "/images/overThinker.webp",
      category: "comedy"
    },
    {
      id: 4,
      title: "Movie Three",
      image: "/images/overThinker.webp",
      category: "comedy"
    }
    ,
    {
      id: 5,
      title: "Movie Three",
      image: "/images/overThinker.webp",
      category: "comedy"
    }
  ];